import React, { useState } from 'react';
const FEATURES = [
  {
    title: "Launch your WiFi business",
    desc: "Create an account and start selling vouchers with a clean and guided flow.",
    icon: "🚀",
  },
  {
    title: "Built for teams & agents",
    desc: "Add staff, monitor sales performance, and manage operations efficiently.",
    icon: "👥",
  },
  {
    title: "Better decisions with data",
    desc: "Track revenue, active users, and devices with clear dashboards.",
    icon: "📈",
  },
  {
    title: "Secure by default",
    desc: "Email verification + strong access controls to protect your business.",
    icon: "✅",
  },
];
const LeftAd = () => {


  // left carousel
  const [activeSlide, setActiveSlide] = useState(0);

  // lightweight auto-rotate without extra libs
  React.useEffect(() => {
    const t = setInterval(() => {
      setActiveSlide((s) => (s + 1) % FEATURES.length);
    }, 4500);
    return () => clearInterval(t);
  }, []);

    return (
         <div className="ofLoginLeft">
            <div className="ofBrand">
              <img
                src="/assets/img/brand/icon-light.png"
                className="ofBrandLogo"
                alt="OpenFi"
              />
              <div className="ofBrandText">
                <div className="ofBrandName">OpenFi</div>
                <div className="ofBrandTag">Public WiFi, managed smarter.</div>
              </div>
            </div>

            <div className="ofFeatureCard">
              <div className="ofFeatureTop">
                <div className="ofFeatureIcon">{FEATURES[activeSlide].icon}</div>
                <div className="ofFeatureTitle">{FEATURES[activeSlide].title}</div>
              </div>
              <div className="ofFeatureDesc">{FEATURES[activeSlide].desc}</div>

              <div className="ofDots">
                {FEATURES.map((_, i) => (
                  <button
                    key={i}
                    type="button"
                    className={`ofDot ${i === activeSlide ? "active" : ""}`}
                    onClick={() => setActiveSlide(i)}
                    aria-label={`Go to slide ${i + 1}`}
                  />
                ))}
              </div>
            </div>

            <div className="ofMiniStats">
              <div className="ofMiniStat">
                <div className="ofMiniStatBig">Fast</div>
                <div className="ofMiniStatSmall">Voucher issuance</div>
              </div>
              <div className="ofMiniStat">
                <div className="ofMiniStatBig">Secure</div>
                <div className="ofMiniStatSmall">Token-based access</div>
              </div>
              <div className="ofMiniStat">
                <div className="ofMiniStatBig">Mobile</div>
                <div className="ofMiniStatSmall">Agent-friendly</div>
              </div>
            </div>
          </div>
    );
};

export default LeftAd;